import { render, staticRenderFns } from "./QuestionTemplates.vue?vue&type=template&id=6060a717&scoped=true&"
import script from "./QuestionTemplates.vue?vue&type=script&lang=ts&"
export * from "./QuestionTemplates.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionTemplates.vue?vue&type=style&index=0&id=6060a717&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6060a717",
  null
  
)

export default component.exports